import React from "react";
import styles from "./PageWrapper.module.css";

interface PageWrapperProps {
  children: React.ReactNode;
  className?: string;
}

const PageWrapper: React.FC<PageWrapperProps> = ({
  children,
  className = "",
}) => {
  return (
    <div className={`${styles.pageWrapper} ${className}`}>
      <div className={styles.content}>{children}</div>
    </div>
  );
};

export default PageWrapper;
